import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "components/Header";
import Footer from "components/Footer";
import { Heading } from "components";
import { Link } from "react-router-dom";
import rehypeRaw from "rehype-raw";

export default function BlogPost() {
  const { id } = useParams();
  const [markdownContent, setMarkdownContent] = useState("");
  const [blogPostList, setBlogPostList] = useState([]);
  const [blogPost, setBlogPost] = useState(null);
  const [recentPosts, setRecentPosts] = useState([]);

  // Fetch the blogPostList.json and update the state
  useEffect(() => {
    fetch("/BlogMarkdowns/BlogList.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to load BlogList.json");
        }
        return response.json();
      })
      .then((data) => {
        setBlogPostList(data);

        // Find the current blog post based on the ID
        const currentPost = data.find((post) => post.blogPostId === parseInt(id));
        setBlogPost(currentPost);

        // Filter recent posts excluding the current one
        const recent = data.filter((post) => post.blogPostId !== parseInt(id));
        setRecentPosts(recent);
      })
      .catch((error) => console.error("Error loading blogPostList:", error));
  }, [id]);

  // Fetch the Markdown content of the current blog post
  useEffect(() => {
    if (blogPost && blogPost.path) {
      fetch(blogPost.path)
        .then((response) => response.text())
        .then((data) => setMarkdownContent(data))
        .catch((error) => console.error("Error loading Markdown file:", error));
    }
  }, [blogPost]);

  return (
    <>
      <Helmet>
        <title>Blog Markdown</title>
        <meta name="description" content="Markdown Description" />
      </Helmet>
      <div className="flex w-full flex-col gap-[148px] bg-white md:gap[111px] sm:gap-[74px]">
        <Header className="rounded-bl-[34px] rounded-br-[34px] bg-blue_gray-900" />
        
        {/* Content Section */}
        <div className="mb-[140px] flex flex-col px-2 sm:px-4">
          <div className="flex flex-col md:flex-row gap-8">
            
            {/* Markdown Content */}
            <div className="markdown-container flex-grow bg-gray-50 p-6 rounded-lg shadow-sm">
              {markdownContent ? (
                <ReactMarkdown rehypePlugins={[rehypeRaw]}>{markdownContent}</ReactMarkdown>
              ) : (
                <p>Loading content...</p>
              )}
            </div>

            {/* Recent Posts Sidebar */}
            <div className="w-full md:w-[20%] flex-shrink-0 shadow-sm rounded-lg p-6 bg-white">
              <Heading size="text2xl" as="h3" className="mb-6">
                Recent Posts
              </Heading>
              <ul className="flex flex-col gap-4">
                {recentPosts.map((post) => (
                  <li key={post.blogPostId}>
                    <Link
                      to={`/blog/${post.blogPostId}`}
                      className="text-blue-600 hover:underline"
                    >
                      {post.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

          </div>
        </div>

        <Footer className="rounded-tl-[34px] rounded-tr-[34px] bg-gradient1 sm:py-5" />
      </div>
    </>
  );
}
